/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from '../../environments/environment';
import {APP_CONFIG} from '../app.config';
import {AccidentCausation} from "../model/AccidentCausation";
import {MessageService} from "./message.service";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AccidentCausationService {

  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/accidentcausations';
  }


  getAll(): Observable<AccidentCausation[]> {
    const url = `${this.baseUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(accidentCausations => accidentCausations as AccidentCausation[]));
  }

  updateAccidentCausationById(accidentCausation: AccidentCausation): Observable<AccidentCausation>{
    const id = accidentCausation.accidentCausationId;
    const url = `${this.baseUrl}/${id}`;

    return this.http.put(url,accidentCausation,httpOptions).pipe(
      map(accidentCausation => accidentCausation as AccidentCausation));
  }

  addAccidentCausation(accidentCausation: AccidentCausation): Observable<AccidentCausation>{
    const url = `${this.baseUrl}`;

    return this.http.post(url,accidentCausation,httpOptions).pipe(
      map(accidentCausation => accidentCausation as AccidentCausation));
  }
}

